import BulkDeleteModal from "../../../../components/BulkDeleteModal";
import { deleteAlarmCode } from "../../../../core/api/responsecenters/alarmcodes";
import useTranslations from "../../../../core/i18n/useTranslations";

export const DeleteAlarmCodeModal = ({
  isOpen,
  responseCenterId,
  ids,
  onClose,
  onDelete,
}: {
  isOpen: boolean;
  responseCenterId: number | string;
  ids: (number | string)[];
  onClose: () => void;
  onDelete: (success: boolean) => void;
}) => {
  const t = useTranslations();

  return (
    <BulkDeleteModal
      isOpen={isOpen}
      onClose={onClose}
      onDelete={onDelete}
      ids={ids.map((id) => id.toString())}
      labels={{
        single: t("AlarmReceptions:alarm_code_type"),
        multi: t("AlarmReceptions:alarm_code_type_multi"),
      }}
      apiFunc={(id, authReq) => deleteAlarmCode(responseCenterId, id, authReq)}
    />
  );
};
